export default "__VITE_ASSET__17640208__"